module.exports = __webpack_public_path__ + "static/media/youtube.c586d534.svg";